import { useFormat } from '@ideavivat/vivat-2';

import {
  _primaryControls,
  _selectorControls,
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  description,
  material_code,
  amount,
  unit,
  surface_treatment,
  target_date,
  _remarksControls,
  leadTime,
  _startDateControls,
  _finishDateControls,
  created_at,
  updated_at,
} from '@/table/Job/SubJob/base';
import { qc_claim_amount } from './subJob-qc';

export default {
  types: {
    _primaryControls,
    _selectorControls,
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    description,
    material_code,
    // _sizeControls: {
    //   name: 'ขนาดชิ้นส่วน',
    //   width: '10rem',
    // },
    size: {
      name: 'ขนาดชิ้นส่วน',
      width: '10rem',
    },
    amount,
    // withdrawn_amount,
    // purchased_amount,
    qc_claim_amount,
    unit,
    // qc_status: {
    //   ...status,
    //   name: 'สถานะ',
    //   filter: (val: string, row: any) => translateQCStatus(row.item.qc_status),
    //   class: {
    //     text: (val: string, row: any) => qcStatusClassMap(row.item.qc_status),
    //   },
    // },
    surface_treatment,
    purchaseCreated: {
      name: 'วันที่เปิด PO',
      width: '7rem',
      filter: (val: any, row: any) => {
        const items = row.item.purchase_order_items.filter((item: any) => item.subType === 'CLAIM');
        if (items.length > 0) return items[0].created_at ? useFormat.date(items[0]?.created_at).displayShortThaiDate() : '';
        return '';
      },
      class: 'text-center',
    },
    purchaseTargetDate: {
      name: 'วันที่คาดว่าจะได้รับ',
      width: '7rem',
      filter: (val: any, row: any) => {
        const items = row.item.purchase_order_items.filter((item: any) => item.subType === 'CLAIM');
        if (items.length > 0) return items[0].target_date ? useFormat.date(items[0]?.target_date).displayShortThaiDate() : '';
        return '';
      },
      class: 'text-center',
    },
    _startDateControls,
    _finishDateControls,
    target_date,
    _remarksControls,
    leadTime,
    created_at,
    updated_at,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    // 'withdrawn_amount',
    // 'purchased_amount',
    'unit',
    'qc_status',
    'surface_treatment',
    'target_date',
    'created_at',
    'updated_at',
  ],
};
